import { configureStore, combineReducers } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { flattenDeep } from 'lodash';

import * as app from './app';
import * as errors from './errors';
import * as auth from './auth';
import * as ui from './ui';
import * as webauthn from './webauthn';
import { createDpopSigner } from '../services/dpop';

import {
  sagas as coreSagas,
  reducers as coreReducers,
  setDpopSigner,
} from '@formue-app/core';

// We have UI reducers in core and web, so we need to merge them

const uiReducer = combineReducers({
  ...coreReducers.ui.all,
  ...ui.reducers.all,
});

const createRootReducer = () =>
  combineReducers({
    api: coreReducers.api,
    entities: coreReducers.entities,
    flags: coreReducers.flags,
    app: app.reducer,
    errors: errors.reducer,
    auth: auth.reducer,
    ui: uiReducer,
    webauthn: webauthn.reducer,
  });

  const sagas = flattenDeep([
  ...coreSagas,
  ...app.sagas,
  ...errors.sagas,
  ...auth.sagas,
  ...ui.sagas,
  ...webauthn.sagas,
]);

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: createRootReducer(),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
      serializableCheck: false,
      immutableCheck: false,
    }).concat(sagaMiddleware),
});

// Bind /oidc sessions to this browser's DPoP key (RFC 9449). Cheap and
// synchronous: the key is only loaded from IndexedDB the first time a request
// needs a proof, so flag-off and legacy sessions never touch it. Set before the
// sagas start so the bootstrap refresh already carries a proof.
setDpopSigner(createDpopSigner());

sagas.forEach((saga) => sagaMiddleware.run(saga));
